/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SandboxUsageBucket,
  SandboxUsageBucket$inboundSchema,
  SandboxUsageBucket$Outbound,
  SandboxUsageBucket$outboundSchema,
} from "./sandboxusagebucket.js";

export type SandboxUsagePage = {
  object?: "page" | undefined;
  data?: Array<SandboxUsageBucket> | undefined;
  hasMore?: boolean | undefined;
  nextPage?: string | null | undefined;
};

/** @internal */
export const SandboxUsagePage$inboundSchema: z.ZodType<
  SandboxUsagePage,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("page").default("page"),
  data: z.array(SandboxUsageBucket$inboundSchema).optional(),
  has_more: z.boolean().default(false),
  next_page: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "has_more": "hasMore",
    "next_page": "nextPage",
  });
});
/** @internal */
export type SandboxUsagePage$Outbound = {
  object: "page";
  data?: Array<SandboxUsageBucket$Outbound> | undefined;
  has_more: boolean;
  next_page?: string | null | undefined;
};

/** @internal */
export const SandboxUsagePage$outboundSchema: z.ZodType<
  SandboxUsagePage$Outbound,
  z.ZodTypeDef,
  SandboxUsagePage
> = z.object({
  object: z.literal("page").default("page" as const),
  data: z.array(SandboxUsageBucket$outboundSchema).optional(),
  hasMore: z.boolean().default(false),
  nextPage: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    hasMore: "has_more",
    nextPage: "next_page",
  });
});

export function sandboxUsagePageToJSON(
  sandboxUsagePage: SandboxUsagePage,
): string {
  return JSON.stringify(
    SandboxUsagePage$outboundSchema.parse(sandboxUsagePage),
  );
}
export function sandboxUsagePageFromJSON(
  jsonString: string,
): SafeParseResult<SandboxUsagePage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SandboxUsagePage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SandboxUsagePage' from JSON`,
  );
}
